import React from "react";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const ActiveDisabledStatus = ({ disabled }: any) => {
  const name = disabled ? "Disabled" : "Active";
  const icon = disabled ? <CancelOutlinedIcon /> : <CheckCircleIcon />;
  const color = disabled ? "#F23E3E" : "#3EA293";

  const theme = createTheme({
    components: {
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            height: "20px",
            width: "20px",
          },
        },
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ color: color }}>
        {icon}
        <span className="text-14-medium ms-2" style={{color: color}}>{name}</span>
      </Box>
    </ThemeProvider>
  );
};

export default ActiveDisabledStatus;
